'use client';

import type { Swiper as SwiperCore } from 'swiper';
import { type FC } from 'react';
import { FloatingButton } from '@yanolja-rnd/nol-design-system';
import { IcArrowbackFill, IcArrowforwardFill } from '@yanolja-rnd/nol-icons';
import { cn } from '@/app/_shared/utils/tw-cn';

export interface NavButtonProps {
  swiperRef: React.MutableRefObject<SwiperCore | null>;
  top?: number;
}

export const SwiperNavButton: FC<NavButtonProps> = ({ swiperRef, top }) => {
  const hasTop = top !== undefined;
  return (
    <>
      <div
        style={{ top: hasTop ? `${top}px` : undefined }}
        className={cn('absolute left-0 z-[1] hidden -translate-x-2/4 pc:block', {
          'top-1/2 -translate-y-2/4': !hasTop,
        })}>
        <FloatingButton icon={<IcArrowbackFill />} onClick={() => swiperRef.current?.slidePrev()} />
      </div>
      <div
        style={{ top: hasTop ? `${top}px` : undefined }}
        className={cn('absolute right-0 top-1/2 z-[1] hidden translate-x-2/4 pc:block', {
          'top-1/2 -translate-y-2/4': !hasTop,
        })}>
        <FloatingButton icon={<IcArrowforwardFill />} onClick={() => swiperRef.current?.slideNext()} />
      </div>
    </>
  );
};
